import * as React from "react";
import Button from "@mui/material/Button"
import Link from "@mui/material/Link";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Title from "../Common/Title";

export default function SessionList({ token }) {
	const get_session = (id_session, time_start, time_end, user_id, user_role, status) => {
		return { id_session, time_start, time_end, user_id, user_role, status };
	}
	
	const [Sessions, setSessions] = React.useState([]);
	const [LimitSessions, setLimitSessions] = React.useState(10);
	
	const update_sessions = async () => {
		fetch(`${process.env.REACT_APP_API_URL}/sessions/listlast/${LimitSessions}`, 
			{
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					"Token": token
				}
			}
		)
		.then((response) => response.json())
		.then((data) => {
			const transformedData = data.map(([id_session, time_start, time_end, user_id, user_role, status]) => {
				// Function to format dates by removing milliseconds
				const formatDate = (dateString) => {
					if (!dateString) return null; // Return null if dateString is null
					const date = new Date(dateString);
					return `${date.toLocaleString().split(".")[0]}`; // Remove milliseconds and retain the "Z" timezone indicator
				};
				
				// Apply formatting to time_start and time_end
				const formattedTimeStart = formatDate(time_start);
				const formattedTimeEnd = formatDate(time_end);
				
				// Return the session object with formatted times
				return get_session(id_session, formattedTimeStart, formattedTimeEnd, user_id, user_role, status);
			});
			
			// Update the sessions state with the transformed and formatted data
			setSessions(transformedData);
		}).catch((error) => console.error("Error fetching sessions:", error));
}

	React.useEffect(() => {
		update_sessions();
	}, [LimitSessions]);

	function preventDefault(event) {
		event.preventDefault();
	}

	return (
		<React.Fragment>
		<Title>Sessions</Title>
		<Table size="small">
			<TableHead>
			<TableRow>
				<TableCell>Session ID</TableCell>
				<TableCell>Start Time</TableCell>
				<TableCell>End Time</TableCell>
				<TableCell>User ID</TableCell>
				<TableCell>User Role</TableCell>
				<TableCell>Status</TableCell>
				<TableCell></TableCell> {/* Add a header for the actions column */}
			</TableRow>
			</TableHead>
			<TableBody>
			{Sessions.map((session) => (
				<TableRow key={session.id_session}> {/* Ensure each row has a unique key */}
				<TableCell>{session.id_session}</TableCell>
				<TableCell>{session.time_start}</TableCell>
				<TableCell>{session.time_end}</TableCell>
				<TableCell>{session.user_id}</TableCell>
				<TableCell>{session.user_role}</TableCell>
				<TableCell>{session.status}</TableCell>
				<TableCell>
					{/* Button to access session log, adjust the onClick function as needed */}
					<Button
					variant="text"
					onClick={() => { window.location.href = `/console/sessions/log/${session.id_session}` }}
					>
					View Log
					</Button>
				</TableCell>
				</TableRow>
			))}
			</TableBody>
		</Table>
		<Link color="primary" onClick={() => setLimitSessions(LimitSessions + 10)} sx={{ mt: 3 }}>
			Load more
		</Link>
		</React.Fragment>
  	);
}